import { render } from "./ExamLock.vue?vue&type=template&id=286b95f8"
import script from "./ExamLock.vue?vue&type=script&lang=js"
export * from "./ExamLock.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__